<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div [fxFlex]="labelFlex">
    {{ textLabel | translate }}*
  </div>

  <div [fxFlex]="formWrapperFlex">
    <form [formGroup]="formGroup"> 
      <mat-form-field class="width-100">
        <mat-chip-list #chipsWebUser aria-label="WebUser" required>
          <mat-chip *ngFor="let data of multiSelect.selectedWebUser"  [removable]="true" (removed)="toggleSelection(data, webUsers, 'selectedWebUser', 'webUser')">
            {{ data.username }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        
          <input 
            matInput 
            required
            #webUserInput 
            [matChipInputFor]="chipsWebUser" 
            formControlName="webUser" 
            [matChipInputAddOnBlur]="true"
            [matAutocomplete]="webUserAC" 
            (focus)="!loading.webUser && getInitialValues('webUser')" 
            (blur)="checkAutocompleteObject(formGroup, 'webUser', 'selectedWebUser')"
            >
        
          <mat-icon 
            matSuffix 
            svgIcon="menu-down" 
            *ngIf="!webUserInput.value" 
            class="autocomplete-arrow-color cursor-pointer"
            (click)="webUserInput.focus()" 
            >
          </mat-icon>
        </mat-chip-list>
 
        <mat-autocomplete 
          id="id_web_user_dropdown"
          [displayWith]="displayFn"
          #webUserAC="matAutocomplete" 
          (opened)="autocompleteScroll('webUser','webUserACRef','webUserACTr')"
          (closed)="autoCmpltClosed()"
          >
        <mat-option
          disabled
          *ngIf="!loading.webUser && webUsers?.length == 0"
          >
          {{ 'MSG_NO_DATA' | translate }}
        </mat-option>

        <ng-container>
          <mat-option [id]="'id_web_user_data_' + (i+1)" *ngFor="let data of webUsers; let i = index" [value]="data" [disabled]="data.disabled">
            <div (click)="optionClicked($event, data, webUsers, 'selectedWebUser', 'webUser', webUserInput)" [class.disable]="data.disabled">
              <mat-checkbox [id]="'id_web_user_data_checkbox' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, webUsers, 'selectedWebUser', 'webUser', webUserInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                {{ data.username }}
              </mat-checkbox>
            </div>
          </mat-option>
        </ng-container>
      
        <mat-option *ngIf="loading.webUser" disabled>
          <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
        </mat-option>
      </mat-autocomplete>

        <mat-error *ngIf="formGroup.get('webUser').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('webUser').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_WEB_USER' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>